var map = {
	"./aliyun-black.svg": 33288,
	"./aliyun.svg": 2026,
	"./aliyunecs-black.svg": 31595,
	"./aliyunecs.svg": 86157,
	"./amazonec2-black.svg": 34642,
	"./amazonec2.svg": 95416,
	"./amazoneks-black.svg": 5663,
	"./amazoneks.svg": 85025,
	"./aws.svg": 42161,
	"./azure-black.svg": 94865,
	"./azure.svg": 35079,
	"./azuread-black.svg": 27146,
	"./azuread.svg": 9952,
	"./azureaks-black.svg": 39972,
	"./azureaks.svg": 64166,
	"./baidu-black.svg": 38221,
	"./baidu.svg": 71123,
	"./cloudca-black.svg": 85707,
	"./cloudca.svg": 63373,
	"./cloudscale-black.svg": 7483,
	"./cloudscale.svg": 39901,
	"./custom.svg": 50603,
	"./digitalocean-black.svg": 56034,
	"./digitalocean.svg": 19752,
	"./equinix-black.svg": 96589,
	"./equinix.svg": 83923,
	"./exoscale.svg": 93646,
	"./gcp.svg": 38436,
	"./gke-black.svg": 45887,
	"./gke.svg": 56801,
	"./google.svg": 55323,
	"./googlegke-black.svg": 5684,
	"./googlegke.svg": 85526,
	"./harvester.svg": 67296,
	"./huaweicce-black.svg": 74718,
	"./huaweicce.svg": 49188,
	"./import.svg": 31109,
	"./k3s-black.svg": 34749,
	"./k3s.svg": 42883,
	"./kubernetes-black.svg": 50420,
	"./kubernetes.svg": 49878,
	"./linode.svg": 95747,
	"./linodelke-black.svg": 46951,
	"./linodelke.svg": 82329,
	"./local-cluster.svg": 19610,
	"./minikube-black.svg": 94802,
	"./minikube.svg": 91544,
	"./nutanix.svg": 41429,
	"./oci-black.svg": 34787,
	"./oci.svg": 30901,
	"./openstack-black.svg": 78988,
	"./openstack.svg": 10654,
	"./oracle.svg": 45240,
	"./oracleoke-black.svg": 72625,
	"./oracleoke.svg": 63815,
	"./otc-black.svg": 34016,
	"./otc.svg": 65714,
	"./otccce.svg": 89617,
	"./outscale.svg": 71996,
	"./ovhcloudmks.svg": 39657,
	"./ovhcloudpubliccloud.svg": 50344,
	"./packet-black.svg": 1116,
	"./packet.svg": 54318,
	"./pinganyunecs-black.svg": 23310,
	"./pinganyunecs.svg": 48340,
	"./pnap-black.svg": 96525,
	"./pnap.svg": 723,
	"./rackspace-black.svg": 96781,
	"./rackspace.svg": 28243,
	"./rke.svg": 67604,
	"./rke2.svg": 23374,
	"./softlayer.svg": 52641,
	"./tencenttke-black.svg": 76761,
	"./tencenttke.svg": 52991,
	"./vmwarevsphere-black.svg": 28665,
	"./vmwarevsphere.svg": 48255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87374;